import { DEFAULT_DINAMIC_MAP_URL } from '../constants';
/** Вставляет скрипт для загрузки яндекс карт в переданный контейнер */
export var appendScript = function appendScript(_ref) {
  var _ref$apiUrl = _ref.apiUrl,
    apiUrl = _ref$apiUrl === void 0 ? DEFAULT_DINAMIC_MAP_URL : _ref$apiUrl,
    onload = _ref.onload,
    onerror = _ref.onerror,
    _ref$container = _ref.container,
    container = _ref$container === void 0 ? window.document.body : _ref$container;
  var e = window.document.createElement('script');
  // tslint:disable-next-line:max-line-length
  e.src = apiUrl;
  e.async = true;
  e.defer = true;
  e.onload = onload;
  e.onerror = onerror;
  container.appendChild(e);
};